module.exports = __webpack_public_path__ + "media/images/logo-6d022ea6a51afaa795250e443af3b1c5.svg";